import React, { Component } from 'react';

export default class About extends Component {
	render() {
		return (
			<h1>About</h1>
		)
	}
}


// WEBPACK FOOTER //
// ./src/Layouts/About.js